var _circle, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeedMechanics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "400.667px",
    height: "400.666px",
    viewBox: "0 0 400.667 400.666",
    enableBackground: "new 0 0 400.667 400.666",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#232323",
    cx: 200.333,
    cy: 200,
    r: 161
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9FF00",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    d: "M57.4,175.086 C43.974,251.226,91.471,314.98,149.825,336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF0000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    d: "M106.854,89.039 c-28.113,23.588-44.001,55.344-49.512,86.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#007511",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    d: "M151.628,336.661 c40.369,14.45,85.524,10.282,121.509-10.494c62.801-36.257,97.126-122.438,53.195-198.528"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 296.814,
    y1: 85.02,
    x2: 281.752,
    y2: 102.968
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 310.03,
    y1: 136.667,
    x2: 330.321,
    y2: 124.953
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 348.149,
    y1: 173.938,
    x2: 325.076,
    y2: 178.006
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 348.149,
    y1: 226.065,
    x2: 325.076,
    y2: 221.997
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 330.32,
    y1: 275.05,
    x2: 310.03,
    y2: 263.336
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 296.812,
    y1: 314.982,
    x2: 281.752,
    y2: 297.035
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 251.667,
    y1: 341.046,
    x2: 243.655,
    y2: 319.031
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 200.331,
    y1: 350.098,
    x2: 200.332,
    y2: 326.67
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 148.995,
    y1: 341.045,
    x2: 157.008,
    y2: 319.03
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 103.85,
    y1: 314.98,
    x2: 118.911,
    y2: 297.034
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 70.343,
    y1: 275.047,
    x2: 90.633,
    y2: 263.334
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 52.515,
    y1: 226.063,
    x2: 75.588,
    y2: 221.995
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 52.516,
    y1: 173.934,
    x2: 75.588,
    y2: 178.004
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 70.346,
    y1: 124.949,
    x2: 90.635,
    y2: 136.666
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 103.854,
    y1: 85.018,
    x2: 118.912,
    y2: 102.967
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 315.313,
    y1: 103.523,
    x2: 303.075,
    y2: 113.797
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 251.669,
    y1: 58.956,
    x2: 243.655,
    y2: 80.973
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 275.381,
    y1: 70.017,
    x2: 267.395,
    y2: 83.855
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 200.333,
    y1: 49.904,
    x2: 200.333,
    y2: 73.334
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 226.398,
    y1: 52.188,
    x2: 223.626,
    y2: 67.923
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 213.417,
    y1: 50.478,
    x2: 212.444,
    y2: 61.619
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 239.182,
    y1: 55.021,
    x2: 236.289,
    y2: 65.824
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 263.767,
    y1: 63.969,
    x2: 259.042,
    y2: 74.105
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 286.424,
    y1: 77.05,
    x2: 280.01,
    y2: 86.212
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 341.376,
    y1: 148.667,
    x2: 326.362,
    y2: 154.136
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 350.427,
    y1: 200.002,
    x2: 334.448,
    y2: 200.006
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 341.375,
    y1: 251.337,
    x2: 326.358,
    y2: 245.876
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 315.312,
    y1: 296.48,
    x2: 303.067,
    y2: 286.213
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 275.38,
    y1: 329.987,
    x2: 267.385,
    y2: 316.15
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 226.396,
    y1: 347.816,
    x2: 223.615,
    y2: 332.079
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 174.268,
    y1: 347.816,
    x2: 177.038,
    y2: 332.077
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 125.284,
    y1: 329.988,
    x2: 133.27,
    y2: 316.145
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 85.351,
    y1: 296.481,
    x2: 97.59,
    y2: 286.203
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 59.287,
    y1: 251.337,
    x2: 74.303,
    y2: 245.864
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 50.235,
    y1: 200,
    x2: 66.217,
    y2: 199.994
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 59.287,
    y1: 148.664,
    x2: 74.307,
    y2: 154.125
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 85.351,
    y1: 103.52,
    x2: 97.598,
    y2: 113.788
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 257.6592 123.6489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "20")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 292.1592 187.1489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "40")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 267.3848 263.3359)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "60")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 225.0059 302.1489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "80")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 153.0015 302.1489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "100")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 107.1592 256.6489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "120")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 91.4746 184.6489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "140")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 125.2837 123.6489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "160")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 175.3799 242.1895)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 14
  }, "KNOTS")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 161.3086 165.1895)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 14
  }, "AIR SPEED")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 194.6592 99.6489)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    fontFamily: "sans-serif",
    fontSize: 20
  }, "0")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedMechanics);
export default __webpack_public_path__ + "static/media/speed_mechanics.88e98fdbd60b678d97db32a69cf5e75e.svg";
export { ForwardRef as ReactComponent };